// src/ui/screens/chats/widgets/TabBarSection.jsx

import React, { useState } from 'react';

const COLORS = {
  card: '#23262C',
};

// ── TabBarSection ────────────────────────────────────────────────────────────

export const TabBarSection = ({ tabs = ['Chats', 'Groups'], onTabChange }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
    if (onTabChange) {
      onTabChange(index);
    }
  };

  return (
    <div className="px-4 py-1.5">
      <div
        className="relative h-11 rounded-full flex items-center p-1"
        style={{
          backgroundColor: 'rgba(35,38,44,0.3)',
          backdropFilter: 'blur(24px)',
          WebkitBackdropFilter: 'blur(24px)',
          border: '1px solid #23262C',
        }}
      >
        {/* Active Tab Indicator */}
        <div
          className="absolute rounded-full transition-all duration-300 ease-in-out"
          style={{
            left: activeTab === 0 ? 4 : '50%',
            width: 'calc(50% - 4px)',
            height: 'calc(100% - 8px)',
            top: 4,
            backgroundColor: COLORS.card,
          }}
        />

        {/* Tab Buttons */}
        {tabs.map((label, index) => (
          <button
            key={index}
            onClick={() => handleTabClick(index)}
            className={`flex-1 h-full rounded-full text-sm font-medium transition-colors duration-200 relative z-10 ${
              activeTab === index
                ? 'text-white'
                : 'text-gray-400'
            }`}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabBarSection;